import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { JsxFragment } from "../JsxFragment";
import { IPanel, Panel, PanelPropertyValues } from "./Panel";
import { NAMESPACE } from "./_Namespace";

export type FormPropertyValues =
    PanelPropertyValues
    & {
        autoComplete: string;
    };

export type FormProperties = {
    [name in keyof FormPropertyValues]: Property<FormPropertyValues[name]>
};

export interface IForm extends IPanel, FormProperties
{
}

export class Form extends Panel implements IForm
{
    // #region Static

    public static override classNamespace = NAMESPACE + "Form";
    public static override className = "Form";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<FormPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public autoComplete!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<FormPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-form");

        // Trigger Property Changes
        this.autoComplete.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _autoCompleteChanged(change: PropertyChange<string>)
    {
        const
            $$element = this.$$element.get();

        if (change.currentValue)
            $$element?.attr("autocomplete", change.currentValue);
        else
            $$element?.removeAttr("autocomplete");
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: FormPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.autoComplete = new PropertyString(this, propertyValues.autoComplete, this._autoCompleteChanged);
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <form ref={this._containerElementRef}>
                {children ?? this._createChildrenHtml()}
            </form>
        );
    }

    // #endregion

    // #endregion
}